import { FC, useEffect, useRef } from 'react';

import AppLayout from 'pages/App';
import AuthLayout from 'pages/Auth';
import useAuth from 'store/auth';
import useMount from 'hooks/useMount';
import useCurrencies from 'store/currencies';
import useConfiguration from 'store/configuration';
import useSockets from 'hooks/useSocket';
import useDynamicManifest from 'hooks/useDynamicManifest';

import Metatags from './Metatags';

type BeforeInstallPromptEvent = Event & { prompt: () => Promise<void> };

const Pages: FC = () => {
  const { connect } = useSockets();

  const [authState] = useAuth();
  const [, currencyActions] = useCurrencies();
  const [, configurationActions] = useConfiguration();

  const deferredPrompt = useRef<BeforeInstallPromptEvent | null>(null);
  const { generated } = useDynamicManifest();

  useMount(() => {
    currencyActions.getPublic();
    configurationActions.getPublic();
  });

  useMount(() => {
    const beforeInstallPromptHandler = (e: Event): void => {
      e.preventDefault();
      deferredPrompt.current = e as BeforeInstallPromptEvent;

      if (generated) {
        deferredPrompt.current.prompt();
      }
    };
    window.addEventListener('beforeinstallprompt', beforeInstallPromptHandler);

    return () => {
      window.removeEventListener('beforeinstallprompt', beforeInstallPromptHandler);
    };
  });

  useEffect(() => {
    if (generated) {
      deferredPrompt.current?.prompt();
    }
  }, [generated]);

  const affiliateId = authState?.data?.affiliate?.id;

  useEffect(() => {
    if (affiliateId) {
      connect();
    }
  }, [affiliateId, connect]);

  return (
    <>
      <Metatags />
      {authState?.data?.accessToken && authState?.data?.affiliate?.id ? <AppLayout /> : <AuthLayout />}
    </>
  );
};

export default Pages;
